export enum AARenewSubscriptionDetailsFormFields {
  PromoCode = 'promoCode',
}
